export default "/assets/images/app-update-img-01.f35beed1c095cfd5.png";